import type { GeoChartColumn, GeoData } from '../../types';
import cn from 'classnames';

export const GeoChartBodyColumn = ({ geoData, column }: { geoData: GeoData; column: GeoChartColumn }) => {
    return (
        <div
            style={{
                width: column.width,
            }}
            className={cn('flex border-r', { 'flex-grow': !column.width })}
        >
            <div className="flex h-full w-full" style={{}}>
                {column.renderBody ? column.renderBody(column, geoData) : null}
            </div>
        </div>
    );
};
